<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<userHeader />
		<fuHeader />
		<dialogBox :dialogFlag="fxFlag" @qrsFn="subFn" @callFn="fxFlag = false" :title="flags == 1 ? `您正在获取听力课本资源` : '分享班级'">
			<el-form :model="ruleForm" ref="ruleForm" :rules="rules" style="width: 430px" label-width="80px">
				<el-form-item label="选择课本" prop="textbookId">
					<el-select style="width: 100%" v-model="ruleForm.textbookId" filterable allow-create default-first-option placeholder="请选择课本">
						<el-option v-for="(item, index) in perData" :key="index" :label="item.title" :value="item.textbookId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择班级" v-if="flags == 2" prop="bjId">
					<el-select style="width: 100%" v-model="ruleForm.bjId" filterable allow-create default-first-option placeholder="请选择班级">
						<el-option v-for="(item, index) in bjList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</dialogBox>
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="searBox">
				<div class="searBoxCont">
					<lunbo :imgArr="bgImgs" lbHeight="320" />
				</div>
				<div class="searBoxRig">
					<div class="searBoxRigXin supHove2" @click="tzBtn('myBanji')">
						<img src="@/assets/img/jxb.svg" class="icon" alt="" />
						<p>我的教学班</p>
						<img src="@/assets/img/jr.svg" class="iconX" alt="" />
					</div>
					<div class="searBoxRigCont">
						<div class="searBoxRigNr" v-if="bjData">
							<div class="searBoxTit">
								<p>班级管理</p>
								<img src="@/assets/img/jinru.svg" class="supHove3" @click="tzBtn('banjiHome', { txt: '班级管理', id: bjData.id, tabFtxt: '首页' })" alt="" />
							</div>
							<p>
								<span>学校</span>
								{{ infoData.school }}
							</p>
							<p>
								<span>班级</span>
								{{ bjData.name }}
							</p>
							<p>
								<span>班号</span>
								{{ bjData.number }}
							</p>
							<div class="searBoxRigNrBot">
								<i class="el-icon-user-solid"></i>
								<span>班级人数</span>
								<p>
									{{ bjData.peopleNumber }}
									<span>人</span>
								</p>
							</div>
						</div>
						<div class="bjBox" style="height: calc(100% - 56px)" v-else>
							<el-empty :image-size="80" description="暂无班级信息"></el-empty>
						</div>
						<div
							class="searBoxRigBot"
							@click="
								tzBtn('myBanji', {
									cjFlag: 1
								})
							"
						>
							<!-- <img src="@/assets/img/tjia.svg" alt=""> -->
							<i class="el-icon-plus"></i>
							<span>创建新班级</span>
						</div>
					</div>
				</div>
			</div>
			<div class="mqBox">
				<div class="mqBoxTop">
					<div class="tabCont">
						<div class="tabContItem" v-for="(item, index) in gkData" :key="index">
							<div class="tabContName">
								{{ item.typeName }}
							</div>
							<div class="tabContRig">
								<div
									class="tabContNum supHove3"
									@click="tabFn(i, index)"
									:class="{
										active:
											(index == 0 && annualClassificationId == i.classificationId) ||
											(index == 1 && gradeClassificationId == i.classificationId) ||
											(index == 2 && versionClassificationId == i.classificationId)
									}"
									v-for="(i, s) in item.arr"
									:key="s"
								>
									{{ i.classificationName }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="mqBoxBot">
					<div class="mqBoxTit">
						<div class="mqBoxTitTabs">
							<div class="mqBoxTitTab" :class="{ tabActive: flags == 1 }" @click="tabKb(1)">课本列表</div>
							<div class="mqBoxTitTab" :class="{ tabActive: flags == 2 }" @click="tabKb(2)">我的课本</div>
						</div>
						<div class="mqBoxTitBtn supHove3" :class="{ mqBoxTitBtn1: flags == 2 }" @click="fxFlag = true">
							<img v-if="flags == 1" src="@/assets/img/xiaz (1).png" alt="" />
							<img v-if="flags == 2" src="@/assets/img/fxIcon.svg" alt="" />
							{{ flags == 1 ? '获取课本' : '分享班级' }}
						</div>
					</div>
					<div class="mqBoxCont" v-if="perData.length">
						<div class="mqBoxContItem supHove5" @click="btnFn(item)" v-for="(item, index) in perData" :key="index">
							<div class="mqBoxContItemImg">
								<el-image :src="$imgUrl + item.coverImg" lazy></el-image>
							</div>
							<p :title="item.title">{{ item.title }}</p>
						</div>
					</div>
					<fenye v-if="perData.length" :total="total" ref="fybox" @dataFn="perList" />
					<div class="mqBoxCont mqBoxCont1" v-if="!perData.length">
						<el-empty description="暂无课本"></el-empty>
					</div>
				</div>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import userHeader from '@/components/hearder/userHeader';
import fuHeader from '@/components/hearder/fuHeader';
import lunbo from '@/components/pubComponents/lunbo';
import dialogBox from '@/components/pubComponents/dialogBox';
import fenye from '@/components/pubComponents/fenye';
import { mapState } from 'vuex';

export default {
	name: 'tingliHome',
	data() {
		return {
			type: 1,
			txt: '',
			fxFlag: false,
			fullscreenLoading: false,
			flags: 1,
			ruleForm: {
				textbookId: '',
				bjId: ''
			},
			rules: {
				textbookId: [{ required: true, message: '请选择课本', trigger: 'change' }],
				bjId: [{ required: true, message: '请选择班级', trigger: 'change' }]
			},
			bjData: '', // 班级信息
			gkData: [
				{
					typeName: '年份',
					arr: [
						{
							classificationName: '全部',
							classificationId: ''
						}
					]
				},
				{
					typeName: '年级',
					arr: [
						{
							classificationName: '全部',
							classificationId: ''
						}
					]
				},
				{
					typeName: '版本',
					arr: [
						{
							classificationName: '全部',
							classificationId: ''
						}
					]
				}
			],
			a: ['个人中心'],
			bjList: [],
			bgImgs: [],
			tabFlag: 1,
			perData: [],
			total: 0,
			annualClassificationId: '', // 年度
			gradeClassificationId: '', // 年级
			versionClassificationId: '' // 版本
		};
	},
	computed: {
		...mapState(['infoData'])
	},
	components: {
		userHeader,
		fuHeader,
		foot,
		lunbo,
		fenye,
		dialogBox
	},
	methods: {
		subFn() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					if (this.flags == 1) {
						let arr = this.perData.filter((item) => item.textbookId == this.ruleForm.textbookId);
						let { content, title } = arr[0];
						let str = JSON.stringify({
							title
							// content,
						});
						this.fxFlag = false;
						this.$router.push({
							path: 'xuqiuSq',
							query: {
								str
							}
						});
					} else {
						console.log(8888);
						let { textbookId, bjId } = this.ruleForm;
						let set = this.$loading(this.$pre);
						this.$http.post(`api/app/yydUserTextbook/add/${textbookId}/${bjId}`).then((res) => {
							set.close();
							if (res.code == 200) {
								this.$message({
									message: '分享成功',
									type: 'success'
								});
								this.fxFlag = false;
							}
						});
					}
					this.$refs.ruleForm.resetFields();
				}
			});
		},
		tabKb(type) {
			this.flags = type;
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		tabFn(item, index) {
			if (index == 0) {
				this.annualClassificationId = item.classificationId;
			} else if (index == 1) {
				this.gradeClassificationId = item.classificationId;
			} else if (index == 2) {
				this.versionClassificationId = item.classificationId;
			}
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		tzBtn(type, qu) {
			this.$router.push({
				path: type,
				query: {
					...qu
				}
			});
		},
		btnFn(item) {
			if (this.flags == 1) {
				return;
			}
			this.$router.push({
				path: './tingliDec',
				query: {
					txt: item.title,
					textbookId: item.textbookId,
					crumFlag: 1,
					tabFtxt: ['首页', '听力课本']
				}
			});
		},
		init() {
			this.$http.get(`api/app/yydBj/list`).then((res) => {
				if (res.code == 200) {
					console.log(res, 444);
					this.bjList = res.rows || [];
				}
			});
			// 班级信息
			this.$http.get('api/app/yydBj/selectYydBjDefult').then((res) => {
				if (res.code == 200) {
					console.log(res, 777);
					this.bjData = res.data;
				}
			});
			// 轮播图
			this.$http
				.get('api/app/yydBanner/list', {
					params: {
						type: 4
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.bgImgs = res.data;
					}
				});
			// 1 课本分类-年级
			this.$http
				.get('api/app/yydQuestionClassification/list', {
					params: {
						categories: 1
					}
				})
				.then((res) => {
					if (res.code == 200) {
						if (res.data.length) {
							this.gkData[1].arr.push(...res.data);
						}
					}
				});
			// 2课本分类-版本
			this.$http
				.get('api/app/yydQuestionClassification/list', {
					params: {
						categories: 2
					}
				})
				.then((res) => {
					if (res.code == 200) {
						if (res.data.length) {
							this.gkData[2].arr.push(...res.data);
						}
					}
				});
			// 3 课本分类-年度
			this.$http
				.get('api/app/yydQuestionClassification/list', {
					params: {
						categories: 3
					}
				})
				.then((res) => {
					if (res.code == 200) {
						if (res.data.length) {
							this.gkData[0].arr.push(...res.data);
						}
					}
				});
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		perList(data) {
			let pre = '';
			if (data) {
				pre = {
					pageNum: data.pageNum,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			this.fullscreenLoading = true;
			let str = '';
			if (this.flags == 1) {
				str = 'api/app/yydTextbook/list';
			} else {
				str = 'api/app/yydTextbook/mylist';
			}
			this.$http
				.get(str, {
					params: {
						annualClassificationId: this.annualClassificationId,
						gradeClassificationId: this.gradeClassificationId,
						versionClassificationId: this.versionClassificationId,
						...pre
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						this.perData = res.rows || [];
						this.total = res.total;
					}
				});
		}
	},
	mounted() {
		const { type, txt } = this.$route.query;
		this.type = type || 1;
		this.txt = txt || '';
		this.a.push(txt);
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.mqBox {
	width: 1200px;
	margin: 0 auto 10px;
	.mqBoxBot {
		margin-bottom: 10px;
		border-radius: 6px;
		background: #fff;
		.mqBoxTit {
			height: 64px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 24px;
			border-bottom: 1px solid #f3f4f7;
			.mqBoxTitBtn {
				width: 100px;
				height: 36px;
				background: linear-gradient(180deg, #ffffff 0%, #f1f1f1 100%);
				border-radius: 7px;
				border: 1px solid #e0e0e0;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 14px;
				color: #000000;
				cursor: pointer;
				img {
					width: 12px;
					height: 14px;
					margin-right: 3px;
				}
			}
			.mqBoxTitBtn1 {
				background: #1d7b3a;
				color: #fff;
			}

			.mqBoxTitTabs {
				font-size: 18px;
				color: #9e9e9e;
				display: flex;
				align-items: center;
				.mqBoxTitTab {
					margin-right: 40px;
					cursor: pointer;
				}
				.tabActive {
					color: #000000;
					font-weight: bold;
				}
			}
		}
	}
	.mqBoxCont {
		padding: 25px 24px;
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		box-sizing: border-box;
		.mqBoxContItem {
			width: calc((100% - 176px) / 5);
			margin-right: 44px;
			cursor: pointer;
			&:nth-of-type(5n) {
				margin-right: 0;
			}
			.mqBoxContItemImg {
				height: 241px;
				img {
					height: 100%;
					width: 100%;
					border-radius: 8px;
				}
			}
			p {
				height: 70px;
				line-height: 70px;
				font-size: 16px;
				overflow: hidden; /* 确保超出容器的内容被裁剪 */
				white-space: nowrap; /* 确保文本在一行内显示 */
				text-overflow: ellipsis; /* 超出部分显示省略号 */
			}
		}
	}
	.mqBoxCont1 {
		justify-content: center;
	}
	.mqBoxTop {
		margin: 10px 0;
		background: #fff;
		border-radius: 6px;
		padding: 24px 20px;
		.tabs {
			margin-bottom: 23px;
			font-size: 16px;
			color: #adadad;
			display: flex;
			.tabItem {
				margin-right: 32px;
				cursor: pointer;
			}
			.tabActive {
				color: #000000;
				font-weight: bold;
			}
		}
	}
	.tabCont {
		.tabContItem {
			display: flex;
			margin-bottom: 13px;
			&:last-of-type {
				margin-bottom: 0;
			}
			.tabContName {
				width: 48px;
				color: #adadad;
				font-size: 14px;
			}
			.tabContRig {
				flex: 1;
				display: flex;
				flex-wrap: wrap;
				font-size: 14px;
				.tabContNum {
					margin-right: 31px;
					margin-bottom: 10px;
					cursor: pointer;
				}
				.active {
					color: #1d7b3a;
				}
			}
		}
	}
}
.searBox {
	display: flex;
	width: 1200px;
	margin: 0 auto;
	margin-top: 10px;
	.searBoxCont {
		flex: 1;
	}
	.searBoxRig {
		margin-left: 10px;
		width: 270px;
		.searBoxRigXin {
			border-radius: 4px;
			background: #ffffff;
			display: flex;
			align-items: center;
			padding: 0 16px 0 18px;
			color: #000000;
			font-size: 18px;
			height: 66px;
			margin-bottom: 10px;
			cursor: pointer;
			.icon {
				width: 24px;
				height: 24px;
				margin-right: 13px;
			}
			p {
				flex: 1;
				font-size: 18px;
			}
			.iconX {
				width: 19px;
				height: 19px;
			}
		}
		.searBoxRigCont {
			padding: 10px 10px 14px;
			background: #fff;
			color: #fff;
			border-radius: 4px;
			height: 244px;
			box-sizing: border-box;
			.searBoxRigNrBot {
				border-radius: 0px 0px 4px 4px;
				height: 34px;
				background: rgba(255, 255, 255, 0.6);
				display: flex;
				align-items: center;
				padding: 0 16px;
				margin-top: 10px;
				img {
					width: 18px;
					height: 18px;
					background: red;
					margin-right: 14px;
				}
				span {
					font-size: 12px;
				}
				p {
					flex: 1;
					font-size: 16px !important;
					margin: 0 !important;
					padding: 0 !important;
					text-align: right;
					span {
						font-size: 12px;
						margin: 0 !important;
					}
				}
			}

			.searBoxRigBot {
				margin-top: 11px;
				height: 45px;
				border-radius: 4px;
				border: 1px solid #1d7b3a;
				display: flex;
				justify-content: center;
				align-items: center;
				color: #1d7b3a;
				font-size: 14px;
				cursor: pointer;
				i {
					font-size: 15px;
					font-weight: bold;
					margin-right: 6px;
				}
				&:hover {
					background: #1d7b3a;
					color: #fff;
				}
			}
			.searBoxRigNr {
				height: 156px;
				background: url('@/assets/img/bg.png') 100% 100%;

				.searBoxTit {
					display: flex;
					align-items: center;
					padding: 7px 7px 0 11px;
					justify-content: space-between;
					p {
						font-size: 16px;
						margin: 0;
						padding: 0;
					}
					img {
						width: 19px;
						height: 19px;
						cursor: pointer;
					}
				}
				p {
					padding: 0 7px 0 11px;
					margin-top: 10px;
					font-size: 12px;
					span {
						margin-right: 19px;
					}
				}
			}
		}
	}
}
::v-deep .bjBox {
	.el-empty {
		padding: 10px;
	}
}
</style>
